/*=========================================================================================
  File Name: moduleKVDRActions.js
  Description: KVDR module actions
  ----------------------------------------------------------------------------------------
  Item Name: KVDR - key value driving role
  Author : Ashwani Bhardwaj
  Email  : bhardwaj.ashwani92@gmail.com
==========================================================================================*/

import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
 
  async fetchKVDR({commit},_id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/kvdr/${_id}`);
      commit('SET_KVDR',resObj.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async findKVDR({commit},orgId) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/kvdr`,
        { params: { orgId : orgId } }
      );
      commit('SET_KVDR',resObj.data.data[0]);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    ///////////////////////////////
   //////// Create KVDR //////////
  ///////////////////////////////

  async createKVDR({commit},kvdrDetails) {
    try {
      const resObj = await axios.post(
        `${constants.apiHost}/kvdr`,
        kvdrDetails
      );
      commit('SET_KVDR',resObj.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
    ///////////////////////////////
   //////// Patch KVDR ///////////
  ///////////////////////////////

  async patchKVDR({commit},{_id,data}) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/kvdr/${_id}`,data
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    /////////////////////////////////
   /////// Create KVDR Role ////////
  /////////////////////////////////

  async createKvdrRole({commit},kvdrRoleDetails) {
    try {
      const resObj = await axios.post(
        `${constants.apiHost}/kvdr-role`,
        kvdrRoleDetails
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },


    ////////////////////////////////////////
   /////////// Find KVDR Role  ////////////
  ////////////////////////////////////////

  async findKvdrRole({commit},query) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/kvdr-role?${query}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    ////////////////////////////////
   ////// Patch KVDR Role /////////
  ////////////////////////////////

  async patchKvdrRole({commit},param) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/kvdr-role?selfId=${param.query}`,param.data
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    /////////////////////////////////
   /////// Delete KVDR Role ////////
  /////////////////////////////////
 
  async deleteKvdrRole({commit},id) {
    try {
      const resObj = await axios.delete(`${constants.apiHost}/kvdr-role`,
      {params : { selfId : id } })
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    ////////////////////////////////////////
   ////// Create KVDR Role Profile ////////
  ////////////////////////////////////////

  async createKvdrRoleProfile({commit},kvdrRoleProfileDetails) {
    try {
      const resObj = await axios.post(
        `${constants.apiHost}/kvdr-role-profile`,
        kvdrRoleProfileDetails
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },

    ////////////////////////////////////////
   /////// Find KVDR Role Profile /////////
  ////////////////////////////////////////

  async findKvdrRoleProfile({commit},query) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/kvdr-role-profile?${query}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },


    ///////////////////////////////////////
   /////// Patch KVDR Role Profile ///////
  ///////////////////////////////////////

  async patchKvdrRoleProfile({commit},param) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/kvdr-role-profile?${param.query}`,param.data
      )
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

    ///////////////////////////////////////
   ////// Delete KVDR Role Profile ///////
  ///////////////////////////////////////

  async deleteKvdrRoleProfile({commit},paramData) {
    try {
      const resObj = await axios.delete(
        `${constants.apiHost}/kvdr-role-profile`,
        {params : paramData })
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  
};
